import { useTranslation } from 'react-i18next'

import { usePageBrowserTabTitle } from '../../../hooks'
import { Auth } from '../Auth'

import { RecoverPasswordForm } from './RecoverPasswordForm'

function Recovery() {
  const { t } = useTranslation()

  usePageBrowserTabTitle({ pageTitle: t('BrowserTab.RecoveryPageTitleKey') })

  return (
    <Auth>
      <RecoverPasswordForm />
    </Auth>
  )
}

export default Recovery
